import netWorkController from "@/http/netWorkController";
import dateUtils from "@/utils/dateUtils";
import createAppDialog from "@/views/CreateAppDialog";
import tipsDialog from "@/views/TipsDialog";
import stringUtils from "@/utils/stringUtils";
import toastUtils from "@/utils/toastUtils";

export default {
    name: "AppListPage",
    //自定义组件注册
    components: {createAppDialog, tipsDialog},
    data() {
        return {
            myAppList: [],
            dialogVisible: false,
            dialogShowType: 1,
            selectApp: {},
            tipsDialogVisible: false,
            tipsDialogTitle: "",
            tipsDialogContent: "",
            tipsDialogRightBtn: "",
            tipsDialogRightBtnType: "primary",
            requestForm: {
                id: null,
                ///当前页数
                pageNum: 1,
                ///一页总数
                pageSize: 10,
                ///总条数
                total: 0,
            },
        }
    },
    methods: {
        switchChange(value) {
            value.accessToken = this.requestForm.accessToken
            netWorkController.setCriticalLogSwitch(value, (result) => {
                if (result.status === 200) {
                    toastUtils.success(this, result.msg)
                } else {
                    toastUtils.warning(this, result.msg)
                    this.pageAppList()
                }
            })
        },
        updateApp(cellValue) {
            this.selectApp = JSON.parse(JSON.stringify(cellValue));
            this.dialogShowType = 2;
            this.dialogVisible = true;
        },
        showCreatAppDialog() {
            this.selectApp = {};
            this.dialogShowType = 1;
            this.dialogVisible = true;
        },
        creatAppClick(value, type) {
            this.dialogVisible = false
            if (value) {
                if (type === 1) {
                    netWorkController.creatApp(this.requestForm.userId, this.requestForm.accessToken, value, (result) => {
                        if (result.status === 200) {
                            this.pageAppList()
                            toastUtils.success(this, "应用创建成功！");
                        } else {
                            toastUtils.warning(this, result.msg);
                        }
                    })
                } else {
                    netWorkController.update(this.requestForm.userId, this.requestForm.accessToken, value, (result) => {
                        if (result.status === 200) {
                            this.pageAppList()
                            toastUtils.success(this, "应用更新成功！");
                        } else {
                            toastUtils.warning(this, result.msg);
                        }
                    })
                }
            }
        },
        showTipsDialog(cellValue, type) {
            if (type === -1) {
                this.selectApp = JSON.parse(JSON.stringify(cellValue));
                this.tipsDialogVisible = true;
                this.tipsDialogTitle = "删除APP";
                this.tipsDialogContent = "确定删除应用：" + cellValue.appName + " ?";
                this.tipsDialogRightBtn = "确认"
                this.tipsDialogRightBtnType = "warning "
            } else {
                this.tipsDialogVisible = true;
                this.tipsDialogTitle = "查看密钥";
                this.tipsDialogContent = cellValue.aesKey;
                this.tipsDialogRightBtn = "复制密钥"
                this.tipsDialogRightBtnType = "primary"
            }
        },
        tipsDialogClick(dialogTitle, dialogContent) {
            this.tipsDialogVisible = false;
            if (dialogContent) {
                if (dialogTitle === "查看密钥") {
                    if (stringUtils.copyToClipboard(dialogContent)) {
                        toastUtils.success(this, "复制成功")
                    } else {
                        toastUtils.warning(this, "复制失败")
                    }
                } else {
                    netWorkController.deleteApp(this.requestForm.userId, this.requestForm.accessToken, this.selectApp, (result) => {
                        if (result.status === 200) {
                            toastUtils.success(this, "删除成功")
                            this.pageAppList();
                        } else {
                            toastUtils.warning(this, result.msg)
                        }
                    })
                }
            }
        },
        formatDate(row, column, cellValue) {
            return dateUtils.timestampToDate(cellValue);
        },
        handleSizeChange(value) {
            this.pageSize = value;
            this.pageAppList()
        },
        handleCurrentChange(value) {
            this.pageNum = value
            this.pageAppList()
        },
        pageAppList() {
            netWorkController.pageAppList(this.requestForm, (result) => {
                if (result.data) {
                    this.requestForm.pageNum = result.data.pageNum;
                    this.requestForm.total = result.data.total;
                    this.myAppList = result.data.list;
                } else {
                    toastUtils.warning(this, result.msg)
                }
            })
        }
    },
    created() {
        const userInfoStr = window.localStorage.getItem("userInfo")
        if (userInfoStr) {
            let userInfo = JSON.parse(userInfoStr)
            this.requestForm.userId = userInfo.id
            this.requestForm.accessToken = userInfo.accessToken
            this.pageAppList();
        }
    },
}